import React, { useState } from 'react';
import Grid from '@mui/joy/Grid';
import FormControl from '@mui/joy/FormControl';
import FormLabel from '@mui/joy/FormLabel';
import Input from '@mui/joy/Input';
import Typography from '@mui/joy/Typography';

export default function StepFour({getDataFromStepFour, damagePiecesPrice}) {

    const handleInputChange = (e) => {
        getDataFromStepFour(e.target.value)
    };

    return (
        <Grid
            container
            direction='row'
            spacing={4}
        >
            <Grid xs={12}>
                <Typography level="h3" sx={{ fontSize: '16px', color: '#434448' }}>قيمة الخصم الصبغ للقطعة الواحدة</Typography>
            </Grid>
            <Grid xs={12}>
                <FormControl sx={{ width: '20%' }}>
                    <FormLabel sx={{ fontSize: '16px', color: '#434448', marginBottom:'10px' }}>قيمة الخصم</FormLabel>
                    <Input 
                        placeholder="00" 
                        type='number' 
                        sx={{ borderRadius: '30px', height: '60px' }}
                        value={damagePiecesPrice}
                        onChange={handleInputChange}
                        />
                </FormControl>
            </Grid>

        </Grid>
    );
}